import { idsIn, movesIn } from './scene-state.js';
/**
 * The limits on change within a lesson (docs/superpowers/specs/2026-09-28-wow-tools-design.md),
 * in one place beside shape-limits.ts: the schema states the ones a schema can
 * (motion-limits.test.ts holds the two together), the validator the rest, and
 * the lesson generator tells a model all of them.
 */
export const MOTION_LIMITS = {
    showPerStep: 12,
    hidePerStep: 12,
    movesPerStep: 8,
    movesPerLesson: 40,
    /** Seconds one move takes. */
    secondsMin: 0.5,
    secondsMax: 10,
    secondsDefault: 2,
    /** A step's changes are done within this, so a step never becomes a video. */
    stepSeconds: 12,
};
/** How the headset plays a step's change when the class moves on by one. */
export const MOTION_TIMING = {
    /** Before anything changes, so the "before" is seen. */
    still: 0.4,
    /** Showing and hiding: growing from or shrinking to almost nothing. */
    pop: 0.5,
    /** Two pulses of light on the step's highlight, once the moves are done. */
    highlight: 1.6,
    /** How white the highlight gets at its brightest. */
    highlightPeak: 0.6,
};
/** Read as a record: the generator's checks call these on answers the schema refused. */
const record = (step) => step;
/** How many things a step changes: each shown, hidden and moved object, and its highlight. */
export function stepChangeCount(step) {
    const s = record(step);
    return (idsIn(s['show']).length +
        idsIn(s['hide']).length +
        movesIn(s['move']).length +
        (typeof s['highlight'] === 'string' ? 1 : 0));
}
/** Whether a step changes anything: what "↻ Nog eens" is offered for. */
export function hasChange(step) {
    return stepChangeCount(step) > 0;
}
/** A move's seconds, or the default when it gives none. */
export function moveSeconds(move) {
    const seconds = move.seconds;
    return typeof seconds === 'number' && Number.isFinite(seconds)
        ? seconds
        : MOTION_LIMITS.secondsDefault;
}
/**
 * How long a step's changes take, from the first to the last: showing and
 * hiding together, then every move together (the longest counts), then the
 * highlight. The still moment before is not a change and is not counted.
 */
export function stepSeconds(step) {
    const s = record(step);
    const pops = idsIn(s['show']).length + idsIn(s['hide']).length > 0 ? MOTION_TIMING.pop : 0;
    const moves = Math.max(0, ...movesIn(s['move']).map((move) => moveSeconds(move)));
    const highlight = typeof s['highlight'] === 'string' ? MOTION_TIMING.highlight : 0;
    return pops + moves + highlight;
}
//# sourceMappingURL=motion-limits.js.map